<template>
    <div class="card">
    <div class="card-header">
      <h5>Airline Costing Report</h5>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-12">
                        <label for="tour_type" class="form-label">Airlines</label>
                        <v-select
                            :options="airlines"
                            label="name"
                            class="m-0"
                            id="airlines"
                            index="name"
                            multiple
                            v-model="airline_costing.airlines"
                        />
                        </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <h6>Airline Booking Date Range</h6>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-6">
                    <dateTimePicker
                        no-label
                        label="From Date"
                        id="bookingDateStrt"
                        format="YYYY-MM-DD"
                        formatted="YYYY-MM-DD"
                        button-color="#ec391e"
                        :only-date="true"
                        color="#ec391e"
                        v-model="airline_costing.booking_start"
                        style="border: 1px solid #DFE5F9"
                    />
                    <small class="text-danger" v-if="errors.booking_start">{{ errors.booking_start }}</small>
                    </div>
                    <div class="col-md-6">
                    <dateTimePicker
                        no-label
                        label="To Date"
                        id="bookingDateEnd"
                        format="YYYY-MM-DD"
                        formatted="YYYY-MM-DD"
                        button-color="#ec391e"
                        color="#ec391e"
                        :only-date="true"
                        v-model="airline_costing.booking_end"
                        :min="airline_costing.booking_start"
                        style="border: 1px solid #DFE5F9"
                    />
                    <small class="text-danger" v-if="errors.booking_end">{{ errors.booking_end }}</small>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <h6>Departure Date Range</h6>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-6">
                    <dateTimePicker
                        no-label
                        label="From Date"
                        id="bookingDateStrt"
                        format="YYYY-MM-DD"
                        formatted="YYYY-MM-DD"
                        button-color="#ec391e"
                        :only-date="true"
                        color="#ec391e"
                        v-model="airline_costing.departure_start"
                        style="border: 1px solid #DFE5F9"
                    />
                    <small class="text-danger" v-if="errors.departure_start">{{ errors.departure_start }}</small>
                    </div>
                    <div class="col-md-6">
                    <dateTimePicker
                        no-label
                        label="To Date"
                        id="bookingDateEnd"
                        format="YYYY-MM-DD"
                        formatted="YYYY-MM-DD"
                        button-color="#ec391e"
                        color="#ec391e"
                        :only-date="true"
                        v-model="airline_costing.departuare_end"
                        :min="airline_costing.departure_start"
                        style="border: 1px solid #DFE5F9"
                    />
                    <small class="text-danger" v-if="errors.departuare_end">{{ errors.departuare_end }}</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer align-items-right">
        <button type="submit" class="button" @click="getReport">
            Generate report
        </button>
    </div>
  </div>
</template>

<script>

export default {
    name: 'TourBookingAirlines',
    props:{
        tours: Array,
        airlines: Array,
    },
    data() {
        return {
            airline_costing: {
                airlines:[],
                booking_start:null,
                booking_end:null,
                departure_start:null,
                departuare_end:null,
            },
            errors: {
                booking_start:null,
                booking_end:null,
                departure_start:null,
                departuare_end:null,
            },
        }
    },
    methods: {
        validateFields(){

            let This = this
            return new Promise((resolve, reject) => {

            let errorCount = 0;

            // Departure Dates validation
            // if(This.airline_costing.departureDateStart && !This.airline_costing.departureDateEnd) {
            //     This.errors.departuare_end = "Please select a valid departure to date"
            //     errorCount +=1
            // }else if(This.airline_costing.departureDateEnd && !This.airline_costing.departureDateStart){
            //     This.errors.departure_start = "Please select a valid departure from date"
            //     errorCount +=1
            // }else{
            //     This.errors.departuare_end = null
            //     This.errors.departure_start = null
            // }

            // // Booking Dates validation 
            // if(This.salesreport.bookingDateStart && !This.salesreport.bookingDateEnd) {
            //     This.errors.booking_end = "Please select a valid booking to date"
            //     errorCount +=1
            // }else if(This.salesreport.bookingDateEnd && !This.salesreport.bookingDateStart){
            //     This.errors.booking_start = "Please select a valid booking from date"
            //     errorCount +=1
            // }else{
            //     This.errors.booking_end = null
            //     This.errors.booking_start = null
            // }
            
            // // Check for Departure date and Booking date
            // if ( !This.salesreport.departureDateStart && !This.salesreport.bookingDateStart) 
            // {
            //     This.errors.departure_start = "Please select departure date or booking date"
            //     This.errors.booking_start = "Please select booking date or departure date"

            //     errorCount +=1
            // }else{
            //     This.errors.departure_start = null
            //     This.errors.booking_start = null
            // }


            if(errorCount == 0 ){
                resolve(true)
            }else{
                reject(true)
            }

            })
        },
        getReport()
        {
            this.validateFields()
            .then((response) => {
                if (response) {
                    this.$store.dispatch("setLoadStatus");
                    
                    fetch(this.$api + 'reports/airline-costing-report', {
                        method: 'POST',
                        body: JSON.stringify({...this.airline_costing}),
                        headers:{
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'Authorization': localStorage.getItem('token')
                        }
                    })
                    .then((res) => {
                        if(res.status === 200) {
                            this.$store.dispatch('setLoadStatus')
                            res.blob().then(response => {
                                const _url = window.URL.createObjectURL(response)
                                const link = document.createElement('a')
                                link.href = _url
                                link.setAttribute('download', 'airline_costing_report.csv')
                                document.body.appendChild(link)
                                link.click();
                            })
                        }
                        else {
                            this.$store.dispatch('setLoadStatus')
                            Promise.race([res.json()])
                            .then(response => {
                                if(response.message) {
                                this.$notify({
                                    type: 'error',
                                    title: response.message
                                });
                                } else {
                                this.$notify({
                                    type: 'error',
                                    title: response.error
                                });
                                }
                            })
                        }
                    })
                }
            })
            .catch(error => console.log(error))

        },
    }        
}
</script>

<style lang="scss" scoped>

</style>